import ViewBase from "../../../../framework/core/mvvm/view_base";
import EventManager from '../../../../manager/event_manager';
import ModuleManager from '../../../../framework/core/module_manager';
import LanguageManager from '../../../../manager/language_manager';
import invitationCountdownManager from '../../../../manager/invitationCountdown_manager';
const {ccclass, property} = cc._decorator;

@ccclass
export default class bindingCellphone_view extends ViewBase {

    @property(cc.Button)
    closeBtn: cc.Button = null
    
    @property(cc.EditBox)

    areaCodeEditorBox = null;

    @property(cc.EditBox)

    mobilePhoneEditorBox = null;

    @property(cc.EditBox)

    invitationEditorBox: cc.EditBox = null;

    @property(cc.Node)

    invitationBtn = null;

    @property(cc.Node)

    CountDown = null;

    @property(cc.Node)

    btnSure = null;

    @property([cc.Node])
    titiles : cc.Node[] = [];

    @property(cc.Node)
    cancelBtn : cc.Node = null;

    countDownFn = null;

    private reg:string = "^[0-9]*$";
    onLoad() {
        this.areaCodeEditorBox.node.on('text-changed', this.callBack, this);
        this.mobilePhoneEditorBox.node.on('text-changed',this.mobilePhoneCallBack,this);
        this.invitationEditorBox.node.on('text-changed',this.invitationCallBack,this,);
    }

    updateStyle(style : number){

        //手机号登录
        if (style == 1) {
            this.titiles[0].active = true;
            this.titiles[1].active = false;
            this.cancelBtn.active = false;
            
        }else{
            this.titiles[1].active = true;
            this.titiles[0].active = false;
            this.cancelBtn.active = true;
        }
       
    }

    onClickInvitation(count:number) {
        cc.log("响应Invitation");
        let self = this;
        if(this.countDownFn)
        {
            this.unschedule(this.countDownFn);
            this.countDownFn = null;
        }
        let sprite = this.invitationBtn.getComponent(cc.Sprite);
        this.CountDown.active = true;
        var label = this.CountDown.getComponentInChildren(cc.Label);
        label.string = count.toString()+'วิ';
        sprite.setState(cc.Sprite.State.GRAY);
        let countDown = count;
        this.countDownFn = function () {
            cc.log("=======7777=============", countDown)
            if (countDown > 1) {
                countDown = countDown - 1
                label.string = countDown.toString() + 'วิ';
            }
            else {
                self.setInvation(false);
                label.string = "";
                self.unschedule(self.countDownFn);
                invitationCountdownManager.instance.resetTime();
            }
        }
        cc.log("====================", countDown)
        this.schedule(this.countDownFn, 1, countDown, 0);
    }
    defaultSet(areaCode:string)
    {
        this.areaCodeEditorBox.string = areaCode;
    }
    setInvation(tf: boolean) {
        this.CountDown.active = tf;
        if (!tf) {
            let sprite = this.invitationBtn.getComponent(cc.Sprite);
            sprite.setState(cc.Sprite.State.NORMAL);
        }
    }
    callBack(editorBox: cc.EditBox)
    {
        // cc.log("输入判断1111");
        // //开头输入零
        // if(this.areaCodeEditorBox.string=="0")
        // {
        //     this.areaCodeEditorBox.string ="";
        //     this.areaCodeEditorBox.textLabel.string ="";
        //     return;
        // }
        if(editorBox.string!="")
        {
            if(editorBox.string.startsWith("+"))
            {
                EventManager.instance.dispatch("refresh_AreaCode",editorBox.string);
            }
            else{
                editorBox.string ="+"+editorBox.string;
                EventManager.instance.dispatch("refresh_AreaCode",editorBox.string);
            }
        }
    }
    mobilePhoneCallBack(editorBox: cc.EditBox)
    {
        if (!editorBox.string.match(this.reg)) {
            cc.log("输入错误字符");
            ModuleManager.instance.toastKey("safeBox_InputNumber");
            this.mobilePhoneEditorBox.string = this.mobilePhoneEditorBox.string.substring(0, editorBox.string.length - 1);
            this.mobilePhoneEditorBox.blur();
        }
    }
    invitationCallBack(editorBox: cc.EditBox)
    {
        if (!editorBox.string.match(this.reg))
        {
            cc.error("请输入数字");
            ModuleManager.instance.toastKey("safeBox_InputNumber");
            this.invitationEditorBox.string = this.invitationEditorBox.string.substring(0, editorBox.string.length - 1);
            this.invitationEditorBox.blur();
        }
    }
    onDisable()
    {
        this.unschedule(this.countDownFn);
    }
}
